import { lazy, Suspense } from "react";
import { PageSkeleton } from "../customs/skeleton/main";
const Main = lazy(() => import("../components/settings/templateEditor/main"));

const Template = () => {
  return (
      <Suspense fallback={<PageSkeleton />}>
        <Main />
      </Suspense>
  );
};

export default Template;
